import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/main/shared/shared.module';

import { ForecastWindspeedComponent } from './forecast-windspeed.component';
import { DataService } from './utils/service/data.service';
import { MapService } from './utils/service/map.service';
import { WindspeedService } from './utils/service/windspeed.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ForecastWindspeedComponent],
  exports: [ForecastWindspeedComponent],
  providers: [DataService, MapService, WindspeedService]
})
export class ForecastWindspeedModule { }
